import React from "react";
import { TextField, MenuItem } from "@mui/material";
import { DocStatus } from "./driverTypes";

/** Compact dropdown for picking a document verification status. */
const DocStatusSelect: React.FC<{ label: string; value: DocStatus; onChange: (val: DocStatus) => void }> = ({ label, value, onChange }) => (
    <TextField
        select
        label={label}
        value={value || DocStatus.MISSING}
        onChange={(e) => onChange(e.target.value as DocStatus)}
        fullWidth
        size="small"
    >
      {Object.values(DocStatus).map((status) => (
          <MenuItem key={status} value={status}>
            {status}
          </MenuItem>
      ))}
    </TextField>
);

export default DocStatusSelect;
